import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { masterReducer } from '../reducers/master';
import { productGroupReducer } from '../reducers/group/Index';
import { productCatogeryReducer } from '../reducers/catogery';
import { shelfReducer } from '../reducers/shelf';
import { productReducer } from '../reducers/product';
import { utilityReducer } from '../reducers/utility';
import { batchReducer } from '../reducers/batch';
import { inventoryAdjustmentReducer } from '../reducers/inventory';
import userReducer from '../reducers/userInfo';
import { vendorReducer } from '../reducers/vendor';
import { purchaseOrderReducer } from '../reducers/purchaseOrder';
import { advanceFilterReducer } from '../reducers/advanceFilter/index';
import { advanceFilterPOReducer } from '../reducers/advanceFilter/purchase_order';
import { advanceFilterPRReducer } from '../reducers/advanceFilter/purchase_receive';
import { advanceFilterPBReducer } from '../reducers/advanceFilter/purchase_bill';
import { advanceFilterPMReducer } from '../reducers/advanceFilter/payment_made';
import { advanceFilterCNReducer } from '../reducers/advanceFilter/credit_note';
import { notificationReducer } from '../reducers/notifications';
import subscriptionReducer from '../reducers/subscriptionSlice/subscriptionSlice.js';
import checkoutReducer from '../reducers/checkoutSlice/checkoutSlice.js';
import { sessionExpireModal } from '../reducers/session';

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['userInfo', 'inventory'],
};

const rootReducer = combineReducers({
	master: masterReducer,
	productGroup: productGroupReducer,
	productCatogery: productCatogeryReducer,
	shelf: shelfReducer,
	product: productReducer,
	utility: utilityReducer,
	batch: batchReducer,
	inventory: inventoryAdjustmentReducer,
	userInfo: userReducer,
	vendorReducer: vendorReducer,
	purchaseOrderReducer: purchaseOrderReducer,
	advanceFilter: advanceFilterReducer,
	advanceFilterPOReducer: advanceFilterPOReducer,
	advanceFilterPRReducer: advanceFilterPRReducer,
	advanceFilterPBReducer: advanceFilterPBReducer,
	advanceFilterPMReducer: advanceFilterPMReducer,
	advanceFilterCNReducer: advanceFilterCNReducer,
	notifications: notificationReducer,
	subscription: subscriptionReducer,
	checkout: checkoutReducer,
	sessionModal: sessionExpireModal,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export const persistor = persistStore(store);
export default store;
